import { NoImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import { UserProfile } from "@ui/internal/components/card";
import { useHandleAction } from "@utils/hook/index.hook";
import { ColumnType } from "@utils/interface/index.interface";
import { StudentPlacementData } from "@utils/interface/journey.interface";
import { useSelectionStore } from "@utils/states/index.state";
import { useMemo } from "react";
interface CloumnListProps {
  refetch?: () => void;
}
const ColumnList = ({ refetch }: CloumnListProps) => {
  const journeyEndpoint = useMemo(() => endpoint["student-placement"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({
    endpoint: journeyEndpoint,
    refetch,
  });
  const columns:ColumnType<StudentPlacementData>[] = useMemo(
    () => [
      {
        name: "ID",
        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row?.id}</span>
        ),
        sortable: true,
      },
      {
        name: "Student",
        cell: (row) => (
          <UserProfile
            username={row.student.user.full_name}
            userdesignation={row.student.user.email}
            userimage={row.student.user.professional_image || NoImage}
          />
        ),
        sortable: false,
      },
      {
        name: "Current Role",
        cell: (row) => <>{row.current_role}</>,
        sortable: false,
      },
      {
        name: "Placement Company",
        cell: (row) => <>{row.current_placement_company}</>,
        sortable: false,
      },
      {
        name: "Actions",
        cell: (row) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <button
              className="text-[#1DA077] cursor-pointer"
              onClick={() => handleAction({ type: "modal-edit", data: row.id })}
              title="Edit"
            >
              Edit
            </button>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );

  return columns;
};

export { ColumnList };

